export default "__VITE_ASSET__DFveTa_s__"